import ReportingFilter from "components/reportingFilter/ReportingFilter";
import ReportingExport from "components/reportingExport/ReportingExport";
import { usePerformanceFilter } from "features/Library/Common/Hooks/usePerformanceFilter";

import "features/Library/Common/utils/performanceSCSSUtils.scss";
import { type RootState } from "features/Application/globaltypes/redux";
import { useAccountFilterShouldShow } from "features/Reporting/Content/queries/useAccountFilterShouldShow";
import { connect, type ConnectedProps } from "react-redux";
import cn from "classnames";
import styles from "./ThreatDefensePerformance.module.scss";
import { FeatureFlags } from "featureFlags";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { ReportUnavailable } from "components/reportUnavailable/ReportUnavailable";
import { usePerformanceBreadcrumbs } from "features/Library/Common/Hooks/usePerformanceBreadcrumbs";
import ThreatDefenseBody from "./ThreatDefenseBody";
import { campaignsStateSelector } from "../../state/selectors";

export type Props = {
  campaignId: number;
  campaignName: string;
} & PropsFromRedux;

const ThreatDefenseReport = ({ campaignId, campaignName, accountId, accountType, publisherId }: Props) => {
  const isReportEnabled = useFeatureFlag(FeatureFlags.ThreatDefenseReport);
  const accountFilterShouldShow = useAccountFilterShouldShow(accountId, accountType, true);

  const [filter, setFilter] = usePerformanceFilter(
    {
      accountId,
      includeDistinct: true,
      includeAccountsDropdown: accountFilterShouldShow,
    },
    publisherId,
  );

  const { domElements, registerBreadcrumb, hasBreadcrumbsToDisplay, goBackNLevels } =
    usePerformanceBreadcrumbs("All Sends");

  if (!isReportEnabled) {
    return <ReportUnavailable />;
  }

  return (
    <div className="performanceRoot">
      <div className="performanceHeader">
        <div className={cn("performanceHeader", styles.header)}>
          {hasBreadcrumbsToDisplay ? <div>{domElements}</div> : <h2 className="performanceTitle">Summary</h2>}
          <div className="performanceActions">
            {/* @ts-ignore */}
            <ReportingFilter
              currentFilter={filter}
              callback={setFilter}
              includeAccountsDropdown={accountFilterShouldShow}
              ignoreInCountAndHide={["type"]}
              includeDistinct
              publisherId={publisherId}
            />
            <ReportingExport />
          </div>
        </div>
      </div>
      <ThreatDefenseBody
        campaignId={campaignId}
        campaignName={campaignName}
        filter={filter}
        registerBreadcrumb={registerBreadcrumb}
        goBackNLevels={goBackNLevels}
      />
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    accountId: state.userProfile.accountId,
    accountType: state.userProfile.accountTypeId,
    publisherId: campaignsStateSelector(state).base.details.campaign.ownerId,
  };
};

const connector = connect(mapStateToProps, null);
export type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedComponent = connector(ThreatDefenseReport);
export default ConnectedComponent;
